import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FooterComponent } from "../../components/footer-site";
import { HeaderComponent } from "../../components/header-site";
import { SolutionSection } from "../../components/solution-section/SolutionSection";
import { useLanguage } from "../../contexts/language";
import "./site.scss";
import { DownloadAppSection } from "../../components/download-app-section/DownloadAppSection";

const FlightPlanningPt = require("../../assets/images/app-images-new-version-pt/flight-planning.png");
const InteractiveAirportsPt = require("../../assets/images/app-images-new-version-pt/interactive-airports.png");
const DashboardPt = require("../../assets/images/app-images-new-version-pt/dashboard.png");

const FlightPlanningEn = require("../../assets/images/app-images-new-version-en/flight-planning.png");
const InteractiveAirportsEn = require("../../assets/images/app-images-new-version-en/interactive-airports.png");
const DashboardEn = require("../../assets/images/app-images-new-version-en/dashboard.png");

export default function AppSolution() {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();
  const isPortuguese = currentLanguage?.startsWith("pt");

  const solutionImages = {
    flightPlanning: isPortuguese ? FlightPlanningPt : FlightPlanningEn,
    interactiveAirports: isPortuguese
      ? InteractiveAirportsPt
      : InteractiveAirportsEn,
    dashboard: isPortuguese ? DashboardPt : DashboardEn,
  };

  const solutionTexts = [
    t("appSolutionParagraph1"),
    t("appSolutionParagraph2"),
    t("appSolutionParagraph3"),
  ];

  const interactiveAirportsTexts = [
    t("appSolutionParagraph1"),
    t("appSolutionParagraph2"),
    t("appSolutionParagraph3"),
  ];

  const aircraftTexts = [
    t("appSolutionParagraph1"),
    t("appSolutionParagraph2"),
    t("appSolutionParagraph3"),
  ];

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <React.Fragment>
      <div className="site app-solution-page">
        <HeaderComponent />

        <main className="app-solution-content">
          <SolutionSection
            id="app"
            category={t("APP")}
            title={t("flightPlanningFeatureTitle")}
            texts={solutionTexts}
            imageUrl={solutionImages.flightPlanning}
            imageAlt={t("flightPlanningFeatureTitle")}
          />

          <SolutionSection
            title={t("interactiveAirportsFeatureTitle")}
            texts={interactiveAirportsTexts}
            imageUrl={solutionImages.interactiveAirports}
            imageAlt={t("interactiveAirportsFeatureTitle")}
          />

          <SolutionSection
            title={t("aircraftRegisterSolutionTitle")}
            texts={aircraftTexts}
            imageUrl={solutionImages.dashboard}
            imageAlt={t("aircraftRegisterSolutionTitle")}
          />
        </main>

        <DownloadAppSection />

        <FooterComponent />
      </div>
    </React.Fragment>
  );
}
